/* Separate, paired service lines; never Shopify variant components. */
(function () {
  'use strict';
  if (window.__gravurSplitCart) return;
  var version = 'ronin-split-cart/v1', feeId = '53452664996107';
  var baseIds = ['53322316382475', '53322321068299', '53322321101067'];
  var colors = {'53322316382475':'Wei\u00df','53322321068299':'Schwarz','53322321101067':'Gr\u00fcn'};
  function build(source, choice, pairId) {
    var id = String(source.get('id')), quantity = Number(source.get('quantity') || 1);
    if (!baseIds.includes(id) || !choice?.design || !/^gravur-[A-Za-z0-9-]{8,100}$/.test(pairId) ||
        !Number.isSafeInteger(quantity) || quantity < 1 || source.get('selling_plan')) throw new Error('Krug und Gestaltung sind noch nicht bereit.');
    var data = new FormData();
    data.append('items[0][id]', id); data.append('items[0][quantity]', String(quantity));
    for (var entry of source.entries()) {
      var match = /^properties\[([^\]]+)\]$/.exec(entry[0]);
      if (!match || /^_gravur_(cart|pair|role|choice)$/.test(match[1])) continue;
      if (typeof entry[1] !== 'string' && !entry[1].size) continue;
      data.append('items[0][properties][' + match[1] + ']', entry[1]);
    }
    var common = {_gravur_cart:version,_gravur_pair:pairId,_gravur_choice:choice.key};
    Object.entries(Object.assign({},common,{_gravur_role:'product',_gravur_id:pairId,Motiv:choice.label})).forEach(function (entry) {
      data.set('items[0][properties][' + entry[0] + ']', entry[1]);
    });
    if (choice.personalized) {
      data.append('items[1][id]', feeId); data.append('items[1][quantity]', String(quantity));
      Object.entries(Object.assign({},common,{_gravur_role:'service','Zu RONIN':colors[id]+' / '+choice.label})).forEach(function (entry) {
        data.append('items[1][properties][' + entry[0] + ']', entry[1]);
      });
    }
    return data;
  }
  function inspect(cart) {
    if (!Array.isArray(cart?.items)) throw new Error('Warenkorb konnte nicht geprueft werden.');
    var pairs = new Map(), errors = [];
    cart.items.forEach(function (item) {
      var p = item.properties || {}, id = String(item.variant_id || item.id);
      if (!p._gravur_cart && !p._gravur_pair && id !== feeId) return;
      var role = baseIds.includes(id) ? 'product' : id === feeId ? 'service' : '';
      if (!role || p._gravur_role !== role || p._gravur_cart !== version ||
          !/^gravur-[A-Za-z0-9-]{8,100}$/.test(p._gravur_pair || '') ||
          !Number.isSafeInteger(item.quantity) || item.quantity < 1 ||
          item.original_price !== (role === 'product' ? 2500 : 500)) {
        errors.push('Eine Gravurposition ist nicht eindeutig zugeordnet.'); return;
      }
      var pair = pairs.get(p._gravur_pair) || {};
      if (pair[role]) errors.push('Eine Gestaltung ist doppelt im Warenkorb.');
      pair[role] = item; pairs.set(p._gravur_pair,pair);
    });
    pairs.forEach(function (pair) {
      var p = pair.product?.properties, s = pair.service?.properties;
      var personal = p && (p._gravur_choice === 'eigenes-motiv' || p._gravur_choice?.startsWith('feierabendkrug'));
      if (!p || p._gravur_id !== p._gravur_pair || (personal && (!s ||
          s._gravur_choice !== p._gravur_choice || pair.product.quantity !== pair.service.quantity)) || (!personal && s))
        errors.push('Krug und individuelle Gravur brauchen dieselbe Menge. Bitte die zusammengehoerigen Positionen pruefen.');
    });
    return { valid: !errors.length, errors: errors, pairs: pairs };
  }
  var checking = false;
  function pendingQuantities(cart, fields) {
    return Array.from(fields).some(function (input) {
      if (!input.getClientRects().length) return false;
      var item = cart.items[Number(input.dataset.index) - 1];
      return !item || item.quantity !== Number(input.value);
    });
  }
  async function checkout(event) {
    var submit = event.type === 'submit' && event.submitter?.name === 'checkout';
    var click = event.type === 'click' && event.target.closest('[name="checkout"], a[href$="/checkout"]');
    if ((!submit && !click) || !document.querySelector('[data-gravur-split]')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (checking) return;
    checking = true;
    try {
      var root = window.Shopify?.routes?.root || '/';
      var response = await fetch(root + 'cart.js', {cache:'no-store'});
      if (!response.ok) throw new Error('Warenkorb konnte nicht geprueft werden. Bitte erneut versuchen.');
      var saved = await response.json(), result = inspect(saved);
      if (pendingQuantities(saved,document.querySelectorAll('input[name="updates[]"][data-index]')))
        throw new Error('Deine Mengen werden noch gespeichert. Bitte einen Moment warten und erneut zur Kasse gehen.');
      if (!result.valid) throw new Error(result.errors[0]);
      window.location.assign(root + 'checkout');
    } catch (error) {
      var notice = document.querySelector('[data-gravur-pair-error]');
      if (!notice) {
        notice = document.createElement('p'); notice.dataset.gravurPairError = '';
        notice.setAttribute('role','alert'); notice.tabIndex = -1;
        var host = document.querySelector('cart-items, cart-drawer') || document.body;
        host.prepend(notice);
      }
      notice.textContent = error.message; notice.focus(); notice.scrollIntoView({block:'center'});
    } finally {checking = false;}
  }
  document.addEventListener('click',checkout,true);
  document.addEventListener('submit',checkout,true);
  window.__gravurSplitCart = {build:build,inspect:inspect,pendingQuantities:pendingQuantities,feeId:feeId,baseIds:baseIds};
})();
